import styles from "./SeeYourAnswers.module.scss";
import Accordion from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion";
import CircleTick from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/TickInCircle32PxFilledGreen";
import { GradingQuestions, GradingAnswer } from "../../Grading/types";
const Yes = () => (
  <div className={styles.answers__response}>
    <CircleTick className={styles.answers__responseIcon} alt="Yes" />
    <span className={styles.answers__responseText}>Yes</span>
  </div>
);

const No = () => (
  <div className={styles.answers__response}>
    <img
      src="/electricals-ui/static/CrossInCircle18PxRed.svg"
      alt="No"
      className={styles.answers__responseIcon}
    />
    <span className={styles.answers__responseText}>No</span>
  </div>
);

type Props = {
  questions?: GradingQuestions[];
  answers?: GradingAnswer[];
};

type Question = {
  id: string;
  question: string;
};

const SeeYourAnswers = ({ questions, answers }: Props) => {
  const getAnswer = (question: Question) =>
    answers?.find((answer) => answer.id === question.id)?.response;

  return (
    <Accordion label="See your answers" className={styles.answers} animated>
      <ul className={styles.answers__questions}>
        {questions?.map((question) => {
          return (
            <li className={styles.answers__question} key={question.question}>
              <p className={styles.answers__label}>{question.question}</p>
              <div className={styles.answers__answer}>
                {getAnswer(question) ? <Yes /> : <No />}
              </div>
            </li>
          );
        })}
      </ul>
    </Accordion>
  );
};

export default SeeYourAnswers;
